export const OpenStatusTypes = {
  OPEN_24_HOURS: 'OPEN24',
  OPENS_TODAY: 'OPENSTODAY',
  OPENS_NEXT: 'OPENSNEXT',
  CLOSES_TODAY: 'CLOSESTODAY',
  CLOSES_NEXT: 'CLOSESNEXT',
  CLOSED: 'CLOSED',
  COMING_SOON: 'COMINGSOON'
};

export const OpenStatusStrings = {
  OPEN_24_HOURS: 'Open 24 Hours',
  CLOSED: 'Closed',
  OPENS_AT: 'Opens at',
  OPEN_NOW: 'Open Now',
  CLOSES_AT: 'Closes at',
  COMING_SOON: 'Coming Soon'
};